var $ec25778fcc632081$exports = {};
$ec25778fcc632081$exports = {
    "breadcrumbs": `Breadcrumbs`
};


export {$ec25778fcc632081$exports as default};
//# sourceMappingURL=de-DE.mjs.map
